/* sds-shared-cart-v1: one cart across www.6dollarshirts.com and custom.6dollarshirts.com */
(function () {
  var NAME = 'sds_cart', DOMAIN = '.6dollarshirts.com', MAX_AGE = 2592000;
  var SYNC_URL = 'https://custom.6dollarshirts.com/api/sites/shared-cart';
  var FEE_KEY = '_print_fee_for', FEE_HANDLE = 'custom-printing-fee';
  var CART_PATHS = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if (!/(^|\.)6dollarshirts\.com$/.test(location.hostname)) return;

  function readCookie(n) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function writeShared(token) {
    if (token && token.indexOf('?key=') > 0 && readCookie(NAME) !== token)
      document.cookie = NAME + '=' + encodeURIComponent(token) + '; domain=' + DOMAIN + '; path=/; max-age=' + MAX_AGE + '; SameSite=Lax; Secure';
  }
  function useCart(token) {
    document.cookie = 'cart=' + encodeURIComponent(token) + '; path=/; max-age=' + MAX_AGE + '; SameSite=Lax';
  }
  function getCart() { return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function isFee(i) { return i.handle === FEE_HANDLE || (i.properties && i.properties[FEE_KEY]); }
  function isDesigned(i) {
    var p = i.properties || {};
    for (var k in p) if (k.indexOf('_decorated_upcharge_price_') === 0) return true;
    return false;
  }
  function refreshDrawer() {
    try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }
  function syncFees(cart) {
    if (!cart.items.some(function (i) { return isFee(i) || isDesigned(i); })) return Promise.resolve(false);
    return fetch(SYNC_URL, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ op: 'sync', cart: cart.token })
    }).then(function (r) { return r.ok ? r.json() : {}; }).then(function (d) { return !!d.changed; }).catch(function () { return false; });
  }

  var busy = false;
  function adopt() {
    var shared = readCookie(NAME);
    return getCart().then(function (current) {
      if (!shared || shared === current.token) { writeShared(current.token); return current; }
      var carry = current.items.filter(function (i) { return !isFee(i); });
      useCart(shared);
      return getCart().then(function (s) {
        if (s.token !== shared) { useCart(current.token); writeShared(current.token); return current; }
        if (!carry.length) return s;
        var items = carry.map(function (i) { return { id: i.variant_id, quantity: i.quantity, properties: i.properties || {} }; });
        return fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(getCart);
      }).then(function (c) {
        return syncFees(c).then(function (changed) { refreshDrawer(); return changed ? getCart() : c; });
      });
    });
  }

  var timer = 0;
  function afterChange() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (busy) return;
      getCart().then(function (c) {
        writeShared(c.token);
        return syncFees(c).then(function (changed) { if (changed) refreshDrawer(); });
      }).catch(function () {});
    }, 400);
  }

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (CART_PATHS.test(url)) p.then(afterChange, function () {});
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (CART_PATHS.test(String(url))) this.addEventListener('loadend', afterChange);
    return origOpen.apply(this, arguments);
  };
  document.addEventListener('submit', function (e) {
    if (e.target && CART_PATHS.test(e.target.action || '')) afterChange();
  }, true);

  // Fee lines can't be removed or re-quantified directly; they follow their shirt.
  function lockFeeRows() {
    var host = document.getElementById('upCart'), r = host && host.shadowRoot;
    if (!r) return;
    if (!r.getElementById('sds-fee-style')) {
      var st = document.createElement('style');
      st.id = 'sds-fee-style';
      st.textContent = '.sds-fee-row .styles_TrashButton__deleteButton__,.sds-fee-row .upcart-product-quantity-minus,.sds-fee-row .upcart-product-quantity-plus,.sds-fee-row [class*=quantityPlus],.sds-fee-row [class*=quantityMinus]{display:none!important}.sds-fee-row .upcart-product-quantity-input{pointer-events:none;border-color:transparent!important;background:transparent!important}';
      r.appendChild(st);
    }
    r.querySelectorAll('a[href*="/products/' + FEE_HANDLE + '"]').forEach(function (a) {
      var row = a;
      while (row.parentElement && !row.parentElement.querySelector('.styles_TrashButton__deleteButton__,.upcart-product-quantity-input')) row = row.parentElement;
      row = row.parentElement || row;
      if (!row.classList.contains('sds-fee-row')) {
        row.classList.add('sds-fee-row');
        var q = row.querySelector('.upcart-product-quantity-input');
        if (q) { q.readOnly = true; q.tabIndex = -1; q.setAttribute('aria-label', 'Printing quantity matches its shirt'); }
      }
      a.removeAttribute('href'); a.setAttribute('aria-disabled', 'true');
    });
  }
  var lockQueued = 0;
  function watchDrawer() {
    var host = document.getElementById('upCart');
    if (!host || !host.shadowRoot) return setTimeout(watchDrawer, 500);
    new MutationObserver(function () {
      if (lockQueued) return;
      lockQueued = requestAnimationFrame(function () { lockQueued = 0; lockFeeRows(); });
    }).observe(host.shadowRoot, { childList: true, subtree: true });
    lockFeeRows();
  }

  busy = true;
  adopt().catch(function () {}).then(function () { busy = false; });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer);
  else watchDrawer();
})();
